import { api } from '../configs/axiosConfigs';

export const getAvailableFilters = async () => {
  const response = await api.get('property_search_criteria/get_filters');
  return response.data;
};
